/** Git's default object format when `extensions.objectformat` is unset. */
export const DEFAULT_REPOSITORY_OBJECT_FORMAT = "sha1";
//# sourceMappingURL=constants.js.map